module.exports = __webpack_public_path__ + "media/images/vehicles-fill-topbar-9bd6beb7eea3c58d24d165f7431bd3a9.svg";